module.exports = __webpack_public_path__ + "static/media/powerBI.fed130f2.png";